<template>
    <div class="cst-survey-answer cst-survey-answer-options">
        <ul>
            <li v-bind:class="{ selected: !!question.answer && question.answer.answerId == answerOption.id}" v-bind:key="answerOption.id" v-for="answerOption in question.answers" v-on:click="answer_question(answerOption)">
                <radio-button :active="!!question.answer && question.answer.answerId == answerOption.id"></radio-button>
                <span v-html="answerOption.text"></span>
            </li>
        </ul>
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    import RadioButton from './RadioButton'

    export default {
      props: ['question'],
      methods: {
        answer_question: function (answer) {
          let answer_data = { 'answerValue': answer.value, 'answerId': answer.id, 'questionId': this.question.id }
          if ('score' in answer) {
            answer_data['answerScore'] = answer['score']
          }
          eventHub.$emit('answer-question', answer_data)
        }
      },
      components: {
        RadioButton
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    ul {
        .option-list;
    }

    span {
        vertical-align: middle;
        margin-left: 0.5em;
    }

</style>


// WEBPACK FOOTER //
// src/components/CardAnswerOption.vue